<template>
  <Modal v-bind="$props" custom @before-close="$emit('before-close')">
    <div class="confirm-modal" data-test="confirm-modal">
      <BravadoText variant="headline-semibold" class="confirm-modal__title">
        <slot name="title">Are you sure?</slot>
      </BravadoText>
      <BravadoText v-if="$slots.default" variant="body" class="confirm-modal__text">
        <slot />
      </BravadoText>
      <div v-if="$slots.actions" class="confirm-modal__actions">
        <slot name="actions" />
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '~/components/common/Modal/Modal';
import BravadoText from '~/components/common/BravadoText/BravadoText';

export default {
  name: 'ConfirmDialog',
  components: {
    Modal,
    BravadoText,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.confirm-modal {
  display: grid;
  grid-row-gap: 15px;
  background: var(--theme-color-card);
  width: 318px;
  padding: 24px;
  border-radius: 8px;

  &__title {
    text-align: center;
    color: var(--theme-color-text);
  }

  &__text {
    text-align: center;
    color: var(--theme-color-text);
    opacity: 0.6;
  }

  &__actions {
    display: grid;
    justify-content: center;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 16px;
  }
}
</style>
